import CryptoJS from 'crypto-js';

const SECRET_KEY = 'your-very-secure-secret-key';

// Encrypt the user ID safely
export const encryptUserId = (userId) => {
  if (!userId) {
    console.error('Invalid user ID:', userId); // Handle invalid user IDs
    return null;
  }
  const stringUserId = userId.toString(); // Ensure it's a string
  return CryptoJS.AES.encrypt(stringUserId, SECRET_KEY).toString();
};

// Decrypt the user ID
export const decryptUserId = (encryptedId) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedId, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};
